import { getData } from '@everfi/reactifi/src/json-api/JsonApiUtils';

export const progressIsComplete = async ({ endpointHost, progressId, accessToken }) => {
  if (!endpointHost || !progressId) return false;

  const base = endpointHost.endsWith('/') ? endpointHost : `${endpointHost}/`;
  const { data } = await getData(`${base}api/v1/progress/${progressId}`, { authToken: accessToken });

  return !!data && !data.preview && data.status === 'completed';
};
